import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {getJsonFromUrl} from '../../../../../utils/url';
import {formatQuerystring} from '../../../../../utils/formatting';

import * as productActionCreators from '../../../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);

import CheckboxList from '../filterElements/CheckboxList';
import NumericSlider from '../filterElements/NumericSlider';
import CarvedIcons from '../filterElements/CarvedIcons';
import FinishIcons from '../filterElements/FinishIcons';
import MensDiamondIcons from '../filterElements/MensDiamondIcons';
import StyleIcons from '../filterElements/StyleIcons';
import ValuesSlider from '../filterElements/ValuesSlider';

class MensBandsFilters extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let urlData = getJsonFromUrl();
    let getData = Object.assign({}, this.props.product.productFilters, urlData);
    let getKeys = Object.keys(getData);
    let hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
      

		this.state = {

      budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
      priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
      priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,

      // This is likely not necesary, as this will "link" to future
      polishedOpen: getKeys.includes('polished'),

      finishOpen: getKeys.includes('finish') || true,
      finishValues: getKeys.includes('finish') ? getData['finish'].toLowerCase().split(',') : [],

      carvedOpen: getKeys.includes('carved') || true,
      carvedValues: getKeys.includes('carved') ? getData['carved'].toLowerCase().split(',') : [],

      mensDiamondOpen: getKeys.includes('mensdiamond'),
      mensDiamondValues: getKeys.includes('mensdiamond') ? getData['mensdiamond'].toLowerCase().split(',') : [],

      metalsOpen: getKeys.includes('metals'),      
      metalsValues: getKeys.includes('metals') ? getData['metals'].toUpperCase().split(',') : null,

      altMetalsOpen: getKeys.includes('altmetals'),      
      altMetalsValues: getKeys.includes('altmetals') ? getData['altmetals'].toLowerCase().split(',') : null,

      designersOpen: getKeys.includes('designers'),
      designersValues: getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null,


      styleOpen: getKeys.includes('style'),
      styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : [],

      queryFilters: {},

      lastReset: Date.now(),
    };

    if(hasQuerystring) {

      let pageNum = getData.currentPage ? parseInt(getData.currentPage) : 1;

      this.props.productSaveProductQueryFilters(getData, 'mensband', pageNum);
      setTimeout(() => {
        this.props.updateMethod(formatQuerystring(this.props.product.productFilters));
      }, 150);
    } else {
      this.props.productSaveProductQueryFilters(getData, 'mensband', 1);
      setTimeout(() => {
        this.props.updateMethod(formatQuerystring(this.props.product.productFilters));
      }, 150);
    }
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getAltMetalData() {
    return [
      {
        name: 'Carbon Fiber',
        value: 'carbonfiber',
      },
      {
        name: 'Tantalum',
        value: 'tantalum',
      },
    ];
  }

  getDesignerData() {
    return [
      {
        name: 'ArtCarved',
        value: 'artcarved',
      },
      {
        name: 'Benchmark',
        value: 'benchmark',
      },
      {
        name: 'Christian Bauer',
        value: 'christianbauer',
      },
      // {
      //   name: 'Coast',
      //   value: 'coast',
      // },
      {
        name: 'Furrer Jacot',
        value: 'furrerjacot',
      },
      // {
      //   name: 'Kirk Kara',
      //   value: 'kirkkara',
      // },
      {
        name: 'Novell',
        value: 'novel',
      },
      {
        name: 'Simon G.',
        value: 'simong',
      },
      {
        name: 'Tacori',
        value: 'tacori',
      },
      {
        name: 'True Romance',
        value: 'trueromanace',
      },
      {
        name: 'Verragio',
        value: 'verragio',
      },
    ];
  }

  getMetalTypeData() {
    return [
      {
        name: 'Yellow Gold',
        value: 'YG',
      },
      {
        name: 'White Gold',
        value: 'WG',
      },
      {
        name: 'Rose Gold',
        value: 'RG',
      },
      {
        name: 'Gray Gold',
        value: 'GG',
      },
      {
        name: 'Platinum',
        value: 'PLAT',
      },
      {
        name: 'Mixed Metal',
        value: 'TT,TRI',
      },
      // {
      //   name: 'Carbon Fiber',
      //   value: 'CARBON',
      // },
      {
        name: 'Tantalum',
        value: 'TANT',
      },
    ]
  }


  toggleFilterElement(element) {

    if(!element) {
      return;
    }

    switch(element) {
      case 'budget':
        this.setState({ budgetOpen: !this.state.budgetOpen });
        return;
      case 'polished':
        this.setState({ polishedOpen: !this.state.polishedOpen });
        return;
      case 'finish':
        this.setState({ finishOpen: !this.state.finishOpen });
        return;
      case 'carved':
        this.setState({ carvedOpen: !this.state.carvedOpen });
        return;
      case 'mensdiamond':
        this.setState({ mensDiamondOpen: !this.state.mensDiamondOpen });
        return;
      case 'metals':
        this.setState({ metalsOpen: !this.state.metalsOpen });
        return;
      case 'altmetals':
        this.setState({ altMetalsOpen: !this.state.altMetalsOpen });
        return;
      case 'designers':
        this.setState({ designersOpen: !this.state.designersOpen });
        return;
      case 'style':
        this.setState({ styleOpen: !this.state.styleOpen });
        return;
      default:
        return;
    }
  }

  getElementClass(element) {

    if(!element) {
      return 'filterItem';
    }

    switch(element) {
      case 'budget':
        return this.state.budgetOpen ? 'filterItem open' : 'filterItem';
      case 'polished':
        return this.state.polishedOpen ? 'filterItem open' : 'filterItem';
      case 'finish':
        return this.state.finishOpen ? 'filterItem open' : 'filterItem';
      case 'carved':
        return this.state.carvedOpen ? 'filterItem open' : 'filterItem';
      case 'mensdiamond':
        return this.state.mensDiamondOpen ? 'filterItem open' : 'filterItem';
      case 'metals':
        return this.state.metalsOpen ? 'filterItem longOpen' : 'filterItem';
      case 'altmetals':
        return this.state.altMetalsOpen ? 'filterItem open' : 'filterItem';
      case 'designers':
        return this.state.designersOpen ? 'filterItem longOpen' : 'filterItem';
      case 'style':
        return this.state.styleOpen ? 'filterItem open' : 'filterItem';
      default:
        return 'filterItem';
    }
  }

  filtersUpdated(filterType = null, filterKeys = null, filterValues = null) {

    // console.log(filterType);

    let newFilters = {};
    for(let i=0; i < filterKeys.length; i++) {
      newFilters[filterKeys[i]] = filterValues[i];
    }

    if(filterType) {
      newFilters['type'] = filterType;
    }

    // console.log(newFilters);

    this.props.productSaveProductQueryFilters(newFilters, 'mensband');
    setTimeout(() => {
      this.props.updateMethod(formatQuerystring(this.props.product.productFilters));
    }, 200);
  }

  searchAction() {
    this.filtersUpdated('mensband', [], []);
    this.props.closeMethod(false);
  }
  
  resetBandFilters() {
    this.setState({
      
      priceMin: 100,
      priceMax: 500000,

      finishValues: [],

      carvedValues: [],

      mensDiamondValues: [],

      metalsValues: null,

      altMetalsValues: null,

      designersValues: null,

      styleValues: [],

      lastReset: Date.now(),

    });

    this.props.productResetProductQueryFilters('mensband');
    setTimeout(() => {
      this.props.updateMethod(formatQuerystring(this.props.product.productFilters));
    }, 150);
  }

	render() {
		return <div className='MensBandsFilters'>
			<div className='rbFilterWrapper'>
        <div className='rbInternalWrapper'>




          <div className={'headerItem filterItem'}>
            <div className='filterHead'>
              <div className='filterLabel'>
                <div className='filterValue'>Men's Bands</div>
                <div className='filterReset' onClick={() => this.resetBandFilters()}>
                  Reset
                </div>
              </div>
            </div>
            <div className='filterBody'></div>
          </div>








          <div className={this.getElementClass('polished')} style={{display: 'none'}}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('polished')}>
              <div className='filterLabel'>
                <div className='filterValue'>Polished</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                


              </div>
            </div>
          </div>



          <div className={this.getElementClass('finish')}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('finish')}>
              <div className='filterLabel'>
                <div className='filterValue'>Finish</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <FinishIcons 
                  refreshData={::this.filtersUpdated} 
                  initData={this.state.finishValues} 
                  resetElement={this.state.lastReset} />
              </div>
            </div>
          </div>



          <div className={this.getElementClass('carved')}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('carved')}>
              <div className='filterLabel'>
                <div className='filterValue'>Style</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <CarvedIcons 
                  refreshData={::this.filtersUpdated} 
                  initData={this.state.carvedValues} 
                  resetElement={this.state.lastReset} />
              </div>
            </div>
          </div>




          <div className={this.getElementClass('mensdiamond')} style={{display: 'none'}}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('mensdiamond')}>
              <div className='filterLabel'>
                <div className='filterValue'>Diamond</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <MensDiamondIcons 
                  refreshData={::this.filtersUpdated} 
                  initData={this.state.mensDiamondValues} 
                  resetElement={this.state.lastReset} />
              </div>
            </div>
          </div>



          <div className={this.getElementClass('metals')}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('metals')}>
              <div className='filterLabel'>
                <div className='filterValue'>Metals</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <CheckboxList 
                  label='Metals'
                  productType='mensband'
                  dataKey='metals'
                  refreshData={::this.filtersUpdated}
                  checkboxData={this.getMetalTypeData()}
                  initData={this.state.metalsValues}
                  resetElement={this.state.lastReset} />
              </div>
            </div>
          </div>



          <div className={this.getElementClass('altmetals')} style={{display: 'none'}}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('altmetals')}>
              <div className='filterLabel'>
                <div className='filterValue'>Alternative Metals</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <CheckboxList 
                  label='Metals'
                  productType='mensband'
                  dataKey='altmetals'
                  refreshData={::this.filtersUpdated}
                  checkboxData={this.getAltMetalData()}
                  initData={this.state.altMetalsValues}
                  resetElement={this.state.lastReset} />
              </div>
            </div>
          </div>


          <div className={this.getElementClass('designers')}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('designers')}>
              <div className='filterLabel'>
                <div className='filterValue'>Designers</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <CheckboxList 
                  label='Designers'
                  productType='mensband'
                  dataKey='designers'
                  refreshData={::this.filtersUpdated}
                  checkboxData={this.getDesignerData()}
                  initData={this.state.designersValues}
                  resetElement={this.state.lastReset} />
              </div>
            </div>
          </div>


          <div className={this.getElementClass('style')} style={{display: 'none'}}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('style')}>
              <div className='filterLabel'>
                <div className='filterValue'>Style</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <StyleIcons 
                  searchType={'mensband'}
                  refreshData={::this.filtersUpdated} 
                  initData={this.state.styleValues}
                  resetElement={this.state.lastReset} />
              </div>
            </div>
          </div>


          <div className='budgetSection'>
            <div className={'budgetItem ' + this.getElementClass('budget')}>
              <div className='filterHead'>
                <div className='filterLabel'>
                  <div className='filterValue' onClick={() => this.toggleFilterElement('budget')}>Price Range</div>
                </div>
                <div className='filterIcon' onClick={() => this.toggleFilterElement('budget')}>+</div>
                <div className='filterIcon openIcon' onClick={() => this.toggleFilterElement('budget')}>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <NumericSlider
                    minValue={100}
                    maxValue={500000}
                    initMinValue={this.state.priceMin}
                    initMaxValue={this.state.priceMax}
                    minKey={'priceMin'}
                    maxKey={'priceMax'}
                    service={'mensband'}
                    format={'currency'}
                    scale={'log'}
                    increment={100}
                    refreshData={::this.filtersUpdated}
                    resetElement={this.state.lastReset} />
                </div>
              </div>
            </div>
          </div>
          




          <div className='submitSection'>
            <button className={'filterSubmitButton dd2ActionButton'} onClick={::this.searchAction}>Search</button>
          </div>
        </div>
      </div>
      <div className='filterSeparation'></div>
		</div>;
	}
}
export default MensBandsFilters;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const MensBandsFiltersContainer = connect(
  mapStateToProps,
  allActionCreators
)(MensBandsFilters);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/filters/MensBandsFilters.jsx